import React, { useState } from 'react';
import { BarChart } from 'lucide-react';
import { StatisticsFilters } from './StatisticsFilters';
import { PropertyStats } from './sections/PropertyStats';
import { FinancialStats } from './sections/FinancialStats';
import { AgentStats } from './sections/AgentStats';
import { TimelineStats } from './sections/TimelineStats';
import { OverviewCharts } from './sections/charts/OverviewCharts';
import { useProperties } from '../../hooks/useProperties';

export const StatisticsPage: React.FC = () => {
  const { properties } = useProperties();
  const [dateRange, setDateRange] = useState<[Date, Date]>([
    new Date(new Date().getFullYear(), 0, 1), // 1er janvier de l'année en cours
    new Date()
  ]);
  const [selectedAgents, setSelectedAgents] = useState<string[]>([]);
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);

  // Filtrer les propriétés selon les critères
  const filteredProperties = properties.filter(property => {
    const inDateRange = property.createdAt >= dateRange[0] && property.createdAt <= dateRange[1];
    const matchesAgent = selectedAgents.length === 0 || selectedAgents.includes(property.agent);
    const matchesType = selectedTypes.length === 0 || selectedTypes.includes(property.type);
    return inDateRange && matchesAgent && matchesType;
  });

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8 flex items-center gap-3">
          <BarChart className="h-8 w-8 text-primary-500" />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Statistiques
          </h1>
        </div>

        <StatisticsFilters
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
          selectedAgents={selectedAgents}
          onAgentsChange={setSelectedAgents}
          selectedTypes={selectedTypes}
          onTypesChange={setSelectedTypes}
        />

        <div className="space-y-8">
          <OverviewCharts 
            properties={filteredProperties}
            dateRange={dateRange}
          />

          <PropertyStats
            dateRange={dateRange}
            selectedAgents={selectedAgents}
            selectedTypes={selectedTypes}
          />

          <FinancialStats
            dateRange={dateRange}
            selectedAgents={selectedAgents}
            selectedTypes={selectedTypes}
          />

          <TimelineStats
            dateRange={dateRange}
            selectedAgents={selectedAgents}
            selectedTypes={selectedTypes}
          />

          <AgentStats
            dateRange={dateRange}
            selectedTypes={selectedTypes}
          />
        </div>
      </div>
    </div>
  );
};